import React, { useState } from "react";

const ADMIN = { user: "nate", pass: "shooters1" };

function Login({ onAdmin, onGuest }) {
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [err, setErr] = useState("");

  function attempt() {
    if (u.trim() === ADMIN.user && p === ADMIN.pass) {
      onAdmin();
    } else {
      setErr("Invalid username or password.");
    }
  }

  const inputStyle = {
    background: "#1c2330",
    border: "1px solid #30363d",
    borderRadius: 8,
    padding: "12px 14px",
    color: "#e6edf3",
    fontSize: 16,
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
  };

  return (
    <div style={{ background: "#0d1117", minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 28 }}>
      <div style={{ textAlign: "center", marginBottom: 32 }}>
        <img 
            src="/logo192.png" 
            alt="NYBWL" 
            style={{ width: 120, height: 120, borderRadius: 24, marginBottom: 4 }} 
        />
        <h1 style={{ color: "#e6edf3", fontSize: 26, fontWeight: 700, margin: "10px 0 4px" }}>
          Wiffle Ball League
        </h1>
        <p style={{ color: "#7d8590", fontSize: 14, margin: 0 }}>
          Official Scorekeeping App
        </p>
      </div>

      <div style={{ width: "100%", maxWidth: 300, display: "flex", flexDirection: "column", gap: 10 }}>
        <input
          style={inputStyle}
          placeholder="Username"
          value={u}
          onChange={(e) => setU(e.target.value)}
          autoCapitalize="none"
        />
        <input
          style={inputStyle}
          type="password"
          placeholder="Password"
          value={p}
          onChange={(e) => setP(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && attempt()}
        />
        {err && (
          <p style={{ color: "#f85149", fontSize: 13, margin: 0 }}>{err}</p>
        )}
        <button
          onClick={attempt}
          style={{ background: "#388bfd", color: "#fff", border: "none", borderRadius: 8, padding: 13, fontSize: 15, fontWeight: 600, cursor: "pointer", marginTop: 4 }}
        >
          Sign In as Admin
        </button>
        <button
          onClick={onGuest}
          style={{ background: "transparent", color: "#7d8590", border: "1px solid #30363d", borderRadius: 8, padding: 12, fontSize: 14, cursor: "pointer" }}
        >
          View Only (No Login)
        </button>
      </div>
    </div>
  );
}

export default Login;